import { createSlice } from "@reduxjs/toolkit";
import moment from "moment/moment";
const initialState = {
  InstantPickingHead: {
    VocTyp: "",
    VocTypName: "",
    VocNo: 0,
    PostDate: new Date(),
    Party: "",
    PartyName: "",
    Loc: "",
    LocName: "",
    DocStatus: "",
    InstancePicking: "",
    BinCode: "",
    BinName: "",
    Status: "",
  },
  InstantPickingList: [
    {
      DocTypCode: "",
      DocTypName: "",
      Date: "",
      Status: "",
    },
  ],
  InstantPickingData: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: "",
    docNo: "",
  },
};

const SliceInstantPicking = createSlice({
  name: "InstantPicking",
  initialState: { value: initialState },

  reducers: {
    InstantPickingHead_Set: (state, action) => {
      state.value.InstantPickingHead = action.payload.InstantPickingHead;
    },
    InstantPickingHead_Status_Set: (state, action) => {
      state.value.InstantPickingHead.Status = action.payload.Status;
    },
    InstantPickingList_Set: (state, action) => {
      state.value.InstantPickingList = action.payload.InstantPickingList;
    },
    InstantPickingData_Set: (state, action) => {
      state.value.InstantPickingData = action.payload.InstantPickingData;
    },
    InstantPicking_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  InstantPickingHead_Set,
  InstantPicking_Init,
  InstantPickingList_Set,
  InstantPickingData_Set,
  InstantPickingHead_Status_Set,
} = SliceInstantPicking.actions;
export default SliceInstantPicking.reducer;
